































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { dictServe } from '@/api/installServer';

@Component({
  components: {},
})
export default class AddUser extends Vue {
  @Prop(Object) row!: any; // 传递给编辑页面-数据对象
  private title = ''; // dialog 标题
  private type = ''; // 触发弹框方式
  scrollbar = true;

  // 表单数据
  private formData: any = {
    id: '',
    name: '', // 字典名称
    description: '', // 字典描述
  };
  // 表单验证规则
  formRules: object = {
    name: [{ required: true, message: '请输入字典名称', trigger: 'blur' }], // 字典名称验证
  };

  created() {
    if (this.row.id) {
      this.type = 'edit';
      this.title = '编辑字典类型';
      this.getDictList(this.row.id);
    } else {
      this.type = 'add';
      this.title = '新增字典类型';
    }
  }

  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.getElementById('main_box');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 保存并提交编辑、新增
   * @param1 暂无
   * @returns 暂无
   */
  save(): void {
    const formComponent: any = this.$refs.form;
    formComponent.validate((valid: any) => {
      if (!valid) {
        return;
      }
      switch (this.type) {
        case 'add':
          this.addFunctionData();
          break;
        case 'edit':
          this.editFunctionData();
          break;
      }
    });
  }

  /**
   * 【接口】新增功能
   */
  private async addFunctionData() {
    dictServe
      .addDictData(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('添加成功');
          this.close(); // 返回到父级页面
        }
      })
      .catch(() => {
        this.$message.error('添加失败,请稍后重试!');
      });
  }

  /**
   * 【接口】编辑功能
   */
  private async editFunctionData() {
    dictServe
      .editDictData(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('保存成功');
          this.close(); // 返回到父级页面
        }
      })
      .catch(() => {
        this.$message.error('保存失败,请稍后重试!');
      });
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击关闭按钮，返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  close(): void {
    this.formData = {
      id: '',
      name: '', // 字典名称
      description: '', // 字典描述
    };
    this.$emit('on-response');
  }

  /**
   * @desc 通过主键查询单条数据
   * @param1 暂无
   * @returns 暂无
   */
  private getDictList(id?: any) {
    // 通过主键查询单条数据
    dictServe
      .getSingleDictData(id)
      .then((res: any) => {
        this.formData = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }
}
